<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Credit Limit Report
					</div>
					<div class="card-body overflow-auto">
						<div class="col-md-12">
							<div class="row">
								<div class="form-group">
									<input type="text" class="form-control" placeholder="Enter phone number" v-model="phone">
								</div>
								<div class="form-group">
									<button class="btn btn-primary" @click="getLimits('/api/getCreditLimitReport')">Search</button>
								</div>
								<div class="form-group">
									<button class="btn btn-danger" @click="reset">Reset</button>
								</div>
								<div class="form-group">
									<button class="btn btn-danger" @click="exportLimits"><i class="fa fa-print"></i> Export</button>
								</div>
							</div>
						</div>
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th>Phone</th>
									<th>Allowed Limit</th>
									<th>Used</th>
									<th>Remaining</th>
									<th>Updated At</th>
									<th>Manage</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="i in limits">
									<td>{{i.phone}}</td>
									<td>{{i.allowed_limit}}</td>
									<td>{{i.used}}</td>
									<td>{{i.remaining}}</td>
									<td>{{i.updated_at}}</td>
									<td>

									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getLimits(pagination.prevPageUrl)"
						  @next="getLimits(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->


<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	this.getLimits();
        },

        data(){
        	return {
        		limits: [],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		phone: null
        	}
        },

        methods:{
        	getLimits(url="/api/getCreditLimitReport"){
        		axios.post(url, {phone: this.phone, paginate: true})
        		.then(response => {
        			this.limits = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	exportLimits(){
        		axios({
							url: "/api/getCreditLimitExport",
							data: {phone: this.phone, paginate: false},
							method: 'post',
							responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "credit_report.xlsx");
        		});
        	},

        	reset(){
        		this.phone = null;
        		this.getLimits();
        	}
        }
    }
</script>
